import { http } from '@/helpers/rest';

export function fetchAllClientsCtor(http, demo) {
  return {
    async execute(companyId = 0) {
      let data;
      // if (demo) {
      const file = await import('@/lib/data/clients.data');
      data = file.default;
      // } else {
      //   const response = await http.get(`/clients/${companyId}`);
      //   data = response.data;
      // }
      return data;
    },
  };
}

export default fetchAllClientsCtor(http, process.env.DEMO);